<div class="modal-header">
  <h2 mat-dialog-title>Remove Attachment from Project</h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <h3>Are you sure you want to remove this document from the project?</h3>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" class="button" (click)="cancel()">Cancel</button>
  <button type="button" class="button action-alert" (click)="deleteProjectAttachment()">Remove</button>
</mat-dialog-actions>
